export default __webpack_public_path__ + "static/media/HeatherHernResume2021.62139885.pdf";